// glyphs.ts -- single source for decorative UI glyphs.
// Phase 2 of docs/text-encoding-hardening-plan.md.
//
// Each value is built from its Unicode code point with String.fromCodePoint so
// THIS file stays pure ASCII (hex digits only) and can never be mojibake'd by an
// edit-through-the-mount. Consumers reference GLYPH.* in JSX / strings instead of
// pasting a literal glyph into component source, which (a) shrinks the mojibake
// surface to this one guarded file and (b) gives a single place to audit the
// icon set. Code points are pinned in glyphs.test.ts.

const g = String.fromCodePoint;

export const GLYPH = {
  // marks
  check: g(0x2713), // check mark
  checkGreen: g(0x2705), // white heavy check mark
  cross: g(0x2715), // multiplication X (close affordance)
  ballotX: g(0x2717), // ballot X
  times: g(0x00d7), // multiplication sign (close affordance)
  // arrows
  arrowLeft: g(0x2190), // leftwards arrow
  arrowRight: g(0x2192), // rightwards arrow
  arrowUp: g(0x2191), // upwards arrow
  arrowDown: g(0x2193), // downwards arrow
  refreshCcw: g(0x21ba), // anticlockwise open circle arrow
  refreshCw: g(0x21bb), // clockwise open circle arrow
  upDown: g(0x2b0d), // up down black arrow
  // shapes
  triangleUp: g(0x25b2), // black up-pointing triangle
  triangleDown: g(0x25bc), // black down-pointing triangle
  diamond: g(0x25c6), // black diamond
  // status / misc symbols
  warning: g(0x26a0), // warning sign (text presentation)
  warningEmoji: g(0x26a0, 0xfe0f), // warning sign + VS16 (emoji presentation)
  noEntry: g(0x26d4), // no entry
  question: g(0x2753), // black question mark ornament
  info: g(0x24d8), // circled latin small letter i
  pencil: g(0x270e), // lower right pencil
  // emoji (astral plane)
  printer: g(0x1f5a8),
  email: g(0x1f4e7), // e-mail symbol
  speech: g(0x1f4ac), // speech balloon
  box: g(0x1f4e6), // package
  clipboard: g(0x1f4cb),
  page: g(0x1f4c4), // page facing up
  paperclip: g(0x1f4ce),
  memo: g(0x1f4dd),
  magnifier: g(0x1f50e), // right-pointing magnifying glass
  lockKey: g(0x1f510), // closed lock with key
  lock: g(0x1f512), // closed lock
  construction: g(0x1f6a7), // construction sign
  party: g(0x1f389), // party popper
  receipt: g(0x1f9fe),
  pointRight: g(0x1f449), // white right pointing backhand index
  thumbsUp: g(0x1f44d), // thumbs up sign
  seeNoEvil: g(0x1f648), // see-no-evil monkey
  eye: g(0x1f441), // eye
} as const;
